import React from "react";
import { Check } from "lucide-react";

export const ProgressBar = ({ step, total, labels = [] }) => {
  return (
    <div data-testid="apply-progress" className="mb-10">
      <div className="hidden sm:flex items-center justify-between">
        {labels.map((label, i) => {
          const stepNumber = i + 1;
          const isCurrent = step === stepNumber;
          const isDone = step > stepNumber;
          return (
            <div
              key={label}
              className="flex items-center gap-3 flex-1 min-w-0"
              data-testid={`apply-step-indicator-${stepNumber}`}
            >
              <div
                className={`flex items-center justify-center w-8 h-8 rounded-full text-xs font-semibold flex-shrink-0 transition-all ${
                  isDone
                    ? "bg-lw-gold text-lw-navy border border-lw-gold"
                    : isCurrent
                      ? "bg-lw-navy text-[#FAF8F3] border border-lw-navy"
                      : "bg-white text-lw-muted border border-lw-navy/15"
                }`}
              >
                {isDone ? <Check size={14} /> : stepNumber}
              </div>
              <span
                className={`font-sans-ui text-xs uppercase tracking-wider truncate ${
                  isCurrent ? "text-lw-navy font-semibold" : "text-lw-muted"
                }`}
              >
                {label}
              </span>
              {i < labels.length - 1 && (
                <div
                  className={`flex-1 h-px ${
                    isDone ? "bg-lw-gold/60" : "bg-lw-navy/15"
                  }`}
                />
              )}
            </div>
          );
        })}
      </div>
      {/* Mobile compact bar */}
      <div className="sm:hidden">
        <div className="flex items-center justify-between mb-2">
          <span className="font-sans-ui text-xs uppercase tracking-wider text-lw-gold font-semibold">
            Step {step} of {total}
          </span>
          <span className="font-sans-ui text-xs text-lw-muted">
            {labels[step - 1]}
          </span>
        </div>
        <div className="h-1.5 w-full rounded-full bg-lw-navy/10 overflow-hidden">
          <div
            className="h-full bg-lw-gold transition-all duration-500"
            style={{ width: `${(step / total) * 100}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
